import configClient from '@catalogo/core-configuration/client';
import configServer from '@catalogo/core-configuration/server';
import getVersion from '@catalogo/shell-web/src/server/helpers/version';
import query from './config.graphql';

export const setConfig = cache => {
  const isServer = typeof window === 'undefined';

  const config = !isServer ? configClient : configServer;
  const version = getVersion(config.brand);
  cache.writeQuery({
    query,
    data: {
      config: { ...config, version },
    },
  });
};
